import React, { memo, useMemo } from 'react';
import { OverlayView } from 'react-google-maps';

import { ensureListing } from '../../util/data';
import { SearchMapGroupLabelWithOverlay } from './components/SearchMapGroupLabelWithOverlay';
import { LABEL_HANDLE } from './SearchMap.helpers.js';

import css from './PriceLabelsInLocations.css';

const shouldSkipRerender = (prev, next) =>
    prev.activeListingId === next.activeListingId &&
    prev.listings === next.listings &&
    prev.listingsScores === next.listingsScores &&
    prev.listingsVisited === next.listingsVisited &&
    prev.mapComponentRefreshToken === next.mapComponentRefreshToken;

const PriceLabelsInLocations = memo(
    ({
        onMarkingListingsAsVisited,
        onFittingMapBoundsWithListings,
        onListingClicked,
        onActivateListing,
        mapComponentRefreshToken,
        activeListingId,
        listings: listingArraysInLocationsStr,
        listingsVisited: listingsVisitedStr,
        listingsScores: listingsScoresStr,
    }) => {
        const listingArraysInLocations = JSON.parse(listingArraysInLocationsStr);
        const listingsVisited = JSON.parse(listingsVisitedStr);
        const listingsScores = JSON.parse(listingsScoresStr);

        const renderLabels = () =>
            listingArraysInLocations.map(listingArr => {
                if (!Array.isArray(listingArr)) return null;

                const isSingle = listingArr.length === 1 && listingArr[0];
                const isActive = activeListingId
                    ? !!listingArr.find(l => activeListingId === l.id.uuid)
                    : false;

                const handleListingClicked = listings => {
                    if (isSingle) {
                        const { id } = listings[0];

                        const listingCardNode = document.getElementById(`ListingCard-${id.uuid}`);
                        listingCardNode &&
                            listingCardNode.scrollIntoView({ block: 'end', behavior: 'smooth' });

                        onMarkingListingsAsVisited(id.uuid);
                        onActivateListing(id.uuid);
                        onListingClicked(listings);
                    } else {
                        onFittingMapBoundsWithListings(listings);
                    }
                };

                const firstListing = ensureListing(listingArr[0]);
                const firstListingId = firstListing.id.uuid;
                const geolocation = firstListing.attributes.geolocation;
                const latLngLiteral = { lat: geolocation.lat, lng: geolocation.lng };
                const isVisited = Boolean(
                    isSingle
                        ? listingsVisited[firstListingId]
                        : listingArr.every(({ id: { uuid } }) => listingsVisited[uuid])
                );

                const palette =
                    typeof listingsScores === 'object' && isSingle && listingsScores[firstListingId]
                        ? listingsScores[firstListingId]
                        : null;

                return (
                    <SearchMapGroupLabelWithOverlay
                        key={firstListingId}
                        position={latLngLiteral}
                        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                        isActive={isActive}
                        isVisited={isVisited}
                        className={LABEL_HANDLE}
                        listings={listingArr}
                        onListingClicked={handleListingClicked}
                        mapComponentRefreshToken={mapComponentRefreshToken}
                        palette={palette}
                    />
                );
            });

        return (
            <div className={css.priceLabelsInLocations}>
                {useMemo(renderLabels, [
                    listingArraysInLocationsStr,
                    activeListingId,
                    listingsScoresStr,
                    listingsVisitedStr,
                ])}
            </div>
        );
    },
    shouldSkipRerender
);

export default PriceLabelsInLocations;
